var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCastbox = function SvgCastbox(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.834.55 6.445 14.38c-1.225.724-2.143 2.33-2.143 3.753v27.731c0 1.423.918 3.03 2.143 3.754l23.389 13.833c1.239.732 3.095.732 4.334 0l23.386-13.833c1.226-.725 2.144-2.331 2.144-3.754v-27.73c0-1.423-.918-3.03-2.144-3.755L34.168.55c-1.239-.732-3.096-.732-4.334 0Z",
    fill: "url(#Castbox_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.818 23.717c-1.05 0-1.9.806-1.9 1.801v4.36c0 .551-.511.997-1.14.997-.63 0-1.141-.446-1.141-.997v-5.931c0-.996-.852-1.803-1.9-1.803-1.051 0-1.901.807-1.901 1.803V28.7c0 .55-.51.997-1.14.997-.63 0-1.14-.448-1.14-.997v-1.723c0-.995-.851-1.803-1.9-1.803-1.05 0-1.9.807-1.9 1.803v4.079c0 .55-.511.997-1.141.997-.629 0-1.14-.447-1.14-.997v-.474a1.894 1.894 0 0 0-1.9-1.886c-1.05 0-1.9.845-1.9 1.886v5.661c0 1.041.85 1.888 1.9 1.888 1.05 0 1.9-.845 1.9-1.888v-.474c0-.55.511-.997 1.14-.997.63 0 1.14.447 1.14.997v6.472c0 .995.85 1.802 1.9 1.802 1.05 0 1.901-.807 1.901-1.802v-8.828c0-.55.51-.997 1.14-.997.63 0 1.14.447 1.14.997v4.448c0 .996.85 1.802 1.9 1.802 1.05 0 1.9-.806 1.9-1.802v-3.27c0-.55.511-.998 1.141-.998.629 0 1.14.448 1.14.998v3.495c0 .995.852 1.802 1.901 1.802 1.05 0 1.9-.806 1.9-1.802V25.518c0-.995-.85-1.801-1.9-1.801ZM41.9 28.586c-1.05 0-1.9.806-1.9 1.802v7.178c0 .995.85 1.802 1.9 1.802 1.049 0 1.9-.806 1.9-1.802v-7.178c-.001-.996-.852-1.802-1.9-1.802ZM47.98 32.236c-1.05 0-1.9.806-1.9 1.802v1.786c0 .995.85 1.803 1.9 1.803 1.05 0 1.9-.806 1.9-1.803v-1.786c0-.996-.85-1.802-1.9-1.802Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Castbox_svg__a",
    x1: 0.42,
    y1: 0.079,
    x2: 71.21,
    y2: 53.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB768"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#FF9953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#FF652E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#FF4518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF390F"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCastbox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "1037d6074800c0ccc09094ce70c2136f.svg";